import { render, staticRenderFns } from "./MesaObrasVisadoPrevioNewOrEdit.vue?vue&type=template&id=5646c832&scoped=true&"
import script from "./MesaObrasVisadoPrevioNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./MesaObrasVisadoPrevioNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./MesaObrasVisadoPrevioNewOrEdit.vue?vue&type=style&index=0&id=5646c832&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5646c832",
  null
  
)

export default component.exports